import React from 'react';

/*
  TODO - Option to select one area and device(s) from that area, if none selected message to select one
  TODO - Option to select date timeframe
  TODO - Option to select date range
  TODO - Graphs of data for the selected area
  TODO - Alerts for the given timeframe in the given area
*/

const AreaDetailReport = () => <div>TODO</div>;

export default AreaDetailReport;
